



import React, { useState, useEffect } from 'react';
import {
  IoHomeOutline,
  IoChevronDown,
  IoChevronUp,
  IoMenu,
  IoClose,
  IoPersonCircleOutline,
} from 'react-icons/io5';
import { TbUserCancel } from 'react-icons/tb';
import {
  FaCog,
  FaTruck,
  FaBox,
  FaWrench,
  FaShoppingCart,
  FaWarehouse,
  FaChartLine,
  FaMoneyBill,
  FaBook,
} from 'react-icons/fa';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSideCollapes, setPhoneToggle } from '../../redux/features/slices/modeSlice';
import { TbReportSearch } from 'react-icons/tb';
import { useGetUserProfileQuery } from '../../redux/features/apiSlices/userApiSlice';
import { setUserProfile } from '../../redux/features/slices/user';
import { useGetCompanyQuery } from '../../redux/features/apiSlices/setup/company';
import { setCompany } from '../../redux/features/slices/setup';
import { Drawer } from 'antd';

import { CiSettings, CiShop } from "react-icons/ci";
import { AiOutlineProduct } from "react-icons/ai";
import { HiOutlineWrenchScrewdriver, HiOutlineHomeModern } from "react-icons/hi2";
import { PiWarehouseLight } from "react-icons/pi";
import { MdOutlinePayments, MdOutlineAccountBalance, MdOutlineSell } from "react-icons/md";

// Link arrays
const links = [
  { id: 1, text: 'Dashboard', icon: <IoHomeOutline size={20} />, path: "/" },
];
const sale = [
  { id: 1, text: 'Sale Invoice', path: "/sale-invoice" },
  { id: 2, text: 'Sale Invoice View', path: "/sale-invoice-view" },
  { id: 3, text: 'Sale Return', path: "/sale-return" },
  { id: 4, text: 'Sale Return View', path: "/sale-return-view" },
  { id: 5, text: 'quotation', path: "/quotation" },
  { id: 6, text: 'quotation view', path: "/quotation-view" },
  { id: 7, text: 'delivery challan', path: "/delivery-challan" },
  { id: 8, text: 'delivery challan view', path: "/delivery-challan-view" },
];
const settings = [
  { id: 1, text: 'Users', path: '/users' },
  { id: 2, text: 'Register', path: "/register" },
  { id: 3, text: 'role & permissions', path: "/role-permission" },
  { id: 4, text: 'Company Setup', path: "/company-setup" },
  { id: 4, text: 'company view', path: "/company-view" },
  { id: 5, text: 'payment method', path: "/payment-method" },
  { id: 6, text: 'barcode generator', path: "/barcode-generator" },
  { id: 7, text: 'product viewer', path: "/product-viewer" },
  { id: 8, text: 'Daily Shifts', path: "/daily-shifts" },
  { id: 9, text: 'General Settings', path: "/general-settings" },
];

const reports = [
  { id: 1, text: 'Sale Report', path: "/sale-report" },
  { id: 2, text: 'Purchase Report', path: "/purchase-report" },
  { id: 3, text: 'Stock Ledger', path: "/stock-ledger-report" },
  { id: 4, text: 'Gross Profit Report', path: "/gross-profit-report" },
  { id: 5, text: 'Account Ledger', path: "/account-ledger-report" },
  { id: 6, text: 'Trial Balance', path: "/trial-balance-report" },
  { id: 7, text: 'Daily Transactions', path: "/daily-transaction-report" },
  { id: 8, text: 'Yearly Expense', path: "/yearly-expense-report" },
  { id: 9, text: 'Outstanding Report', path: "/outstanding-report" },
  { id: 10, text: 'Max Sale Product', path: "/max-sale-product-report" },
  { id: 11, text: 'Unsold Products', path: "/unsold-product-report" },
  { id: 12, text: 'Aging Payable', path: "/aging-payable-report" },
  { id: 13, text: 'Aging Receivable', path: "/aging-receivable-report" },
  { id: 14, text: 'Product Wise Sale', path: "/product-wise-sale-report" },
  { id: 15, text: 'Stock Position', path: "/stock-position-report" },
  { id: 16, text: 'Sale Return', path: "/sale-return-report" },
  { id: 17, text: 'Purchase Return', path: "/purchase-return-report" },
  { id: 18, text: 'Daily Sales', path: "/daily-sales-report" },
];

const productLinks = [
  { id: 1, text: 'Product Type', path: "/product-type" },
  { id: 2, text: 'Brand', path: "/add-brand" },
  { id: 3, text: 'Category', path: "/add-category" },
  { id: 4, text: 'Sub Category', path: "/add-subcategory" },
  { id: 5, text: 'Unit', path: "/add-unit" },
  { id: 6, text: 'New Product', path: "/add-product" },
  { id: 7, text: 'Product', path: "/product" },
  { id: 8, text: 'Pack Type', path: "/packtype" },
];

const setupLinks = [
  { id: 1, text: 'Vendor', path: "/vendor" },
  { id: 2, text: 'Warehouse', path: "/warehouse" },
  { id: 3, text: 'Customers', path: "/customers" },
  { id: 8, text: 'Vendor View', path: "/vendor-view" },
  { id: 9, text: 'Customer Category', path: "/add-customer-category" },
  { id: 10, text: 'Customer Category View', path: "/customer-view-category" },
  { id: 11, text: 'Add Town', path: "/add-town" },
  { id: 12, text: 'Town View', path: "/town-view" },
  { id: 13, text: 'Add Zone', path: "/add-zone" },
  { id: 14, text: 'Zone View', path: "/zone-view" },

  { id: 15, text: 'Warehouse View', path: "/warehouse-view" },
  { id: 16, text: 'Add Saleman', path: "/add-saleman" },
  { id: 17, text: 'Saleman View', path: "/saleman-view" },
  { id: 18, text: 'Customers View', path: "/customers-view" },
  { id: 19, text: 'Add Patty Category', path: "/add-patty-category" },
  { id: 20, text: 'Patty Category View', path: "/patty-category-view" },
  // { id: 21, text: 'GST Type', path: "/gst-type" },
  // { id: 22, text: 'Schedule Type', path: "/schedule-type" },
  // { id: 23, text: 'Advance Tax', path: "/advance-tax" },
  // { id: 24, text: 'Add Device', path: "/add-device" },
];

const purchaseLinks = [
  // { id: 1, text: 'Purchase Order', path: "/purchase-order" },
  { id: 1, text: 'Purchase Invoice', path: "/purchase-invoice" },
  { id: 2, text: 'Purchase Return', path: "/purchase-return" },
  { id: 3, text: 'Purchase Return View', path: "/purchase-return-view" },
  // { id: 6, text: 'Purchase Orders View', path: "/purchase-orders-view" },
  { id: 4, text: 'Purchase Invoice View', path: "/purchase-invoice-view" },
  { id: 5, text: 'Add Purchase', path: "/add-purchase" },
];

const inventoryLinks = [
  { id: 1, text: 'Inventory', path: "/get-inventory" }
];

const stockLinks = [
  { id: 1, text: 'Stock Value', path: "/stockvalue" },
  { id: 2, text: 'Stock Adjustment', path: "/stockadjustment" },
];

const paymentsLink = [
  { id: 1, text: 'Purchase Payment', path: "/payment-voucher" },
  { id: 2, text: 'Receive Payment', path: "/recieve-voucher" },
  { id: 3, text: 'Journal Payment', path: "/journal-payment" },
  { id: 4, text: 'Journal Payment View', path: "/journal-payment-view" },
  { id: 5, text: 'Patty Payment', path: "/patty-payment" },
  { id: 6, text: 'Patty Payment View', path: "/patty-payment-view" },
  { id: 7, text: 'Receive Payment View', path: "/receive-payment-view" },
  { id: 8, text: 'Purchase Payment View', path: "/purchase-payment-view" },
];

const accounts = [
  { id: 1, text: 'Chart of Accounts', path: "/chart-of-accounts" },
];

// Export sections at the top level
export const sections = {
  main: links,
  settings: settings,
  sale: sale,
  products: productLinks,
  reports: reports,
  setup: setupLinks,
  purchase: purchaseLinks,
  inventory: inventoryLinks,
  stock: stockLinks,
  payments: paymentsLink,
  accounts: accounts,
};

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false); // Mobile toggle
  const { sideBarCollapes } = useSelector((state) => state.mode);
  const { user: userProfile } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);

  const { data: user, isLoading, error } = useGetUserProfileQuery();
  const { data: company } = useGetCompanyQuery();

  useEffect(() => {
    if (user) {
      dispatch(setUserProfile(user));
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (company) {
      dispatch(setCompany(company));
    }
  }, [company, dispatch]);

  // Get user permissions
  const permissions = userProfile?.roleAndPermission?.permissions || [];

  // Normalize text for comparison
  const normalizeText = (text) => {
    if (!text || typeof text !== 'string') return '';
    return text.toLowerCase().replace(/\s+/g, '');
  };

  // Filter links based on user permissions
  const filterLinks = (linksArray) => {
    if (!linksArray) return [];
    return linksArray.filter((link) => {
      if (!link || !link.text) return false;

      // Always permit certain paths to ensure reports always show up
      const alwaysPermit = [
        '/sale-report', '/purchase-report', '/stock-ledger-report',
        '/gross-profit-report', '/account-ledger-report', '/trial-balance-report',
        '/daily-transaction-report', '/yearly-expense-report', '/outstanding-report',
        '/max-sale-product-report', '/unsold-product-report', '/aging-payable-report',
        '/aging-receivable-report', '/product-wise-sale-report', '/stock-position-report',
        '/sale-return-report', '/purchase-return-report', '/daily-sales-report', '/'
      ];
      if (alwaysPermit.includes(link.path)) return true;

      if (!permissions || permissions.length === 0) return false;
      return permissions.some(
        (perm) => perm && normalizeText(perm) === normalizeText(link.text)
      );
    });
  };

  // Get all permitted paths
  const getPermittedPaths = () => {
    const allLinks = Object.values(sections).flat();
    return filterLinks(allLinks).map((link) => link.path);
  };

  // Check if current path is allowed, redirect if not
  useEffect(() => {
    if (isLoading || !userProfile) return;
    const permittedPaths = getPermittedPaths();
    const currentPath = location.pathname;
    if (!permittedPaths.includes(currentPath) && currentPath !== '/not-authorized') {
      navigate('/not-authorized');
    }
  }, [location.pathname, userProfile, isLoading, navigate]);

  // Set initial open dropdown based on active route
  useEffect(() => {
    if (!userProfile) return;
    const currentPath = location.pathname;
    const activeSection = Object.keys(sections).find((section) => {
      const filteredLinks = filterLinks(sections[section]);
      return filteredLinks.some((link) => link.path === currentPath);
    });
    setOpenDropdown(activeSection || null);
  }, [location.pathname, userProfile]);

  const togglePhoneSidebar = () => {
    setIsOpen(!isOpen);
    dispatch(setPhoneToggle());
  };

  const toggleDropdown = (section) => {
    if (sideBarCollapes === 'hide' && window.innerWidth >= 768) {
      dispatch(setSideCollapes('show'));
    }
    setOpenDropdown(openDropdown === section ? null : section);
  };

  const sectionIcons = {
    main: <HiOutlineHomeModern size={20} />,
    settings: <CiSettings size={20} />,
    products: <AiOutlineProduct size={20} />,
    reports: <TbReportSearch size={20} />,
    setup: <HiOutlineWrenchScrewdriver size={20} />,
    sale: <HiOutlineWrenchScrewdriver size={20} />,
    purchase: <CiShop size={20} />,
    inventory: <PiWarehouseLight size={20} />,
    stock: <FaChartLine size={20} />,
    payments: <MdOutlinePayments size={20} />,
    accounts: <MdOutlineAccountBalance size={20} />,
  };

  const renderLinks = (linksArray, sectionTitle, sectionKey) => {
    // Filter submenu links based on permissions
    const filteredLinks = filterLinks(linksArray);

    // Only render the section if it has permitted links
    if (filteredLinks.length === 0) {
      return null;
    }

    return (
      <div className="mb-2 relative transition-all duration-300 ease-in-out">
        <button
          onClick={() => toggleDropdown(sectionKey)}
          className={`flex items-center w-full p-3 text-gray-800 hover:bg-blue-400 text-sm transition-colors
            ${filteredLinks.some((link) => link.path === location.pathname) ? 'bg-blue-600 text-white' : ''}
            ${sideBarCollapes === 'hide' && !isOpen ? 'justify-center' : 'justify-between'}`}
        >
          <div className="flex items-center">
            <span className={sideBarCollapes === 'hide' && !isOpen ? '' : 'mr-3'}>{sectionIcons[sectionKey]}</span>
            {(sideBarCollapes !== 'hide' || isOpen) && <span className="font-medium">{sectionTitle}</span>}
          </div>
          {(sideBarCollapes !== 'hide' || isOpen) && (
            <span>{openDropdown === sectionKey ? <IoChevronUp size={16} /> : <IoChevronDown size={16} />}</span>
          )}
        </button>
        <ul
          className={`transition-all duration-300 ease-in-out
            ${sideBarCollapes === 'hide' && !isOpen
              ? `absolute left-full top-0 ml-1 bg-white w-56 shadow-lg z-50 max-h-[80vh] overflow-y-auto
                ${openDropdown === sectionKey
                ? 'opacity-100 translate-x-0'
                : 'opacity-0 translate-x-2 pointer-events-none'}`
              : openDropdown === sectionKey
                ? 'max-h-[1000px] pl-4 opacity-100 overflow-y-auto transition-all duration-500'
                : 'max-h-0 opacity-0 overflow-hidden'
            }`}
        >
          {filteredLinks.map((link) => (
            <li key={link.id} className="mb-1">
              <NavLink
                to={link.path}
                className={({ isActive }) =>
                  `flex items-center p-3 text-gray-800 hover:bg-blue-50 text-sm transition-colors
                  ${isActive ? 'bg-blue-100 border-l-4 border-blue-500' : ''}`
                }
                onClick={() => {
                  setOpenDropdown(sectionKey);
                  if (isOpen) setIsOpen(false);
                }}
              >
                {link.icon && <span className="mr-3">{link.icon}</span>}
                <span>{link.text}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const coll = sideBarCollapes === 'hide';

  const logo = (
    <div className="logo my-2 flex items-center justify-center">
      <div className={`flex  justify-center items-center relative px-4 h-[4rem] border-b-[1px] border-gray-300`}>
        <span className={`text-5xl ${coll && !isOpen ? 'block text-center' : 'hidden'} italic text-sky-700`}>X</span>
        <div className={`${coll && !isOpen ? 'hidden' : 'flex'} flex-col gap-0`}>
          <img src={`${process.env.REACT_APP_BASE_URL}/${company?.logo}`} className='w-20' />
        </div>
      </div>
    </div>
  );

  const profile = (
    <div className="p-4 border-t border-gray-300">
      <div className="flex items-center">
        <IoPersonCircleOutline size={28} className={coll && !isOpen ? '' : 'mr-2'} />
        {(!coll || isOpen) && (
          <div className="min-w-0">
            <p className="text-sm font-medium truncate">{userProfile?.username || 'Admin User'}</p>
            <p className="text-xs text-gray-500 truncate">{userProfile?.email || 'admin@example.com'}</p>
          </div>
        )}
      </div>
    </div>
  );

  const sidebarContent = (
    <div className="h-full flex flex-col">
      {logo}
      <div className="flex-1 overflow-y-auto px-2">
        <nav className="transition-all duration-300 ease-in-out">
          {renderLinks(sections.main, 'Main', 'main')}
          {renderLinks(sections.settings, 'Settings', 'settings')}
          {renderLinks(sections.setup, 'Setup', 'setup')}
          {renderLinks(sections.products, 'Products', 'products')}
          {renderLinks(sections.purchase, 'Purchase', 'purchase')}
          {renderLinks(sections.sale, 'Sale', 'sale')}
          {renderLinks(sections.inventory, 'Inventory', 'inventory')}
          {renderLinks(sections.stock, 'Stock', 'stock')}
          {renderLinks(sections.payments, 'Payments', 'payments')}
          {renderLinks(sections.accounts, 'Accounts', 'accounts')}
          {renderLinks(sections.reports, 'Reports', 'reports')}
        </nav>
      </div>
      {profile}
    </div>
  );

  return (
    <>
      {/* Mobile Toggle Button */}
      {isOpen ? (
        <button
          className="md:hidden fixed top-4 left-36 z-50 text-gray-800 p-2 bg-white rounded-full shadow-lg"
          onClick={togglePhoneSidebar}
        >
          <IoClose size={20} />
        </button>
      ) : (
        <button
          className="md:hidden fixed top-4 left-5 z-50 text-gray-800 p-2 bg-white rounded-full shadow-lg"
          onClick={togglePhoneSidebar}
        >
          <IoMenu size={20} />
        </button>
      )}

      {/* Desktop Sidebar */}
      <div
        className={`h-screen bg-white text-gray-800 transition-all duration-300 z-40 hidden md:block shadow-lg overflow-hidden
          ${sideBarCollapes === 'hide' ? 'w-0' : 'w-56'}`}
      >
        {sidebarContent}
      </div>

      {/* Mobile Drawer */}
      <Drawer
        placement="left"
        closable={false}
        onClose={togglePhoneSidebar}
        open={isOpen}
        width={224}
        styles={{
          body: { padding: 0, background: 'white', height: '100%', overflow: 'hidden' },
          header: { display: 'none' }
        }}
        className="md:hidden"
      >
        {sidebarContent}
      </Drawer>
    </>
  );
};

export default Sidebar;




